<template>
  <base-dialog show-close :visible.sync="visible" class="save-connect-company-dialog">
    <template v-slot:header>{{ title }}</template>
    <el-form
      ref="form"
      :model="connectCompany"
      label-width="110px"
      :rules="rules"
      label-position="left"
    >
      <el-form-item label="企业名称" prop="targetId">
        <el-select
          v-model="connectCompany.targetId"
          :disabled="isEdit"
          filterable
          remote
          :remote-method="debouncedRemoteMethod"
          placeholder="请输入企业名称或管理员手机号搜索"
          :loading="searching"
        >
          <el-option
            v-for="company in companies"
            :key="company.id"
            :label="company.text"
            :value="company.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="互联角色" v-show="!passive" prop="typeIds">
        <el-select v-model="connectCompany.typeIds" multiple filterable>
          <el-option
            v-for="type in types"
            :key="type.id"
            :label="type.name"
            :value="type.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="description">
        <el-input v-model="connectCompany.description"></el-input>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="submit">确认</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import {
  createCompanyConnect,
  getCompanyConnectType,
  searchCompanyList,
  updateCompanyConnect
} from "@/api/connect"

export default {
  name: "save-connect-company-dialog",
  components: { BaseDialog, BaseButton },
  data() {
    return {
      visible: false,
      connectCompany: {},
      companies: [],
      types: [],
      rules: {
        targetId: [{ required: true, message: "请选择企业", trigger: "blur" }],
        typeIds: [{ required: true, message: "请选择互联类型", trigger: "blur" }]
      },
      debouncedRemoteMethod: null,
      searching: false
    }
  },
  props: {
    passive: Boolean
  },
  computed: {
    title() {
      return this.isEdit ? "编辑互联企业" : "添加互联企业"
    },
    isEdit() {
      return Boolean(this.connectCompany.id)
    }
  },
  created() {
    getCompanyConnectType().then(data => {
      this.types = data
    })
    this.debouncedRemoteMethod = this._.debounce(this.remoteMethod, 300)
  },
  methods: {
    open(connectCompany) {
      this.connectCompany = connectCompany ? this._.cloneDeep(connectCompany) : {}
      if (this.connectCompany.targetId) {
        // 因为企业选择是远程搜索,编辑的时候不可编辑,所以这里需要初始化选项
        this.companies = [
          { id: this.connectCompany.targetId, text: this.connectCompany.targetName }
        ]
      }
      this.visible = true
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        if (this.isEdit) {
          updateCompanyConnect(this.connectCompany).then(res => {
            this.$message.success("修改成功")
            this.$emit("change", res)
            this.visible = false
          })
        } else {
          createCompanyConnect(this.connectCompany).then(res => {
            this.$message.success("创建成功")
            this.$emit("change", res)
            this.visible = false
          })
        }
        this.$emit("change", this.connectCompany)
      })
    },
    remoteMethod(query) {
      if (!query) {
        this.companies = []
        return
      }
      this.searching = true
      searchCompanyList(query)
        .then(res => {
          this.companies = res.map(company => {
            company.text = `${company.name}(${company.shortName},${company.owner.name},${company.owner.telephone})`
            return company
          })
        })
        .finally(() => (this.searching = false))
    }
  }
}
</script>

<style lang="scss" scoped>
.save-connect-company-dialog {
  .el-select {
    width: 100%;
  }
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 18px 60px 8px 24px;
      color: unset;
    }
  }
}
</style>
